import { render, staticRenderFns } from "./OfferShow.vue?vue&type=template&id=b8833d82&scoped=true&"
import script from "./OfferShow.vue?vue&type=script&lang=js&"
export * from "./OfferShow.vue?vue&type=script&lang=js&"
import style0 from "./OfferShow.vue?vue&type=style&index=0&id=b8833d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8833d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8833d82')) {
      api.createRecord('b8833d82', component.options)
    } else {
      api.reload('b8833d82', component.options)
    }
    module.hot.accept("./OfferShow.vue?vue&type=template&id=b8833d82&scoped=true&", function () {
      api.rerender('b8833d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/OfferShow.vue"
export default component.exports